import { Component, OnInit, ChangeDetectorRef, AfterContentChecked, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { IItem } from '@coreui/angular-pro'
import { RestService } from 'src/app/services/rest/rest.service';
import { GenericResponse, RetailCustomerList } from 'src/app/interfaces/apiresponses'; 
import { DatePipe } from '@angular/common';
import * as _ from 'lodash';


@Component({

  selector: 'app-retail-customerlist',
  templateUrl: './retail-customerList.component.html',
  styleUrls: ['./retail-customerList.component.scss'],
  providers:[DatePipe]

})
export class RetailCustomerListComponent {
  selectedItem: any
  
  RetailCustomers: any = []
  RetailCustomerTable: any = []
  columns: any = []
  getRowValueData: any;

  constructor(private restApi: RestService,private datePipe: DatePipe) {}
  
  ngOnInit() {
    this.getRetailCustomerList();
  }
  getRetailCustomerList(){
    this.restApi.getRetailCustomersList().subscribe({
      next:(v:RetailCustomerList)=>{
        if(v.success) {

          // Populate the Id column in the data
          this.RetailCustomerTable = v.retailCustomers.map((item, id) => ({
            ...item            
            //,_selected: this.selectedItems.includes(id)
          }));

          // Dynamically generate columns, excluding the 'Id' column
          if (v.retailCustomers.length > 0) {
            this.columns = Object.keys(v.retailCustomers[0])
              .filter(key => key !== 'id')        
              .map(key => ({
               key: key,
               label: key.charAt(0).toUpperCase() + key.slice(1)
              }));
          }

        };
      },
      error:(e)=>{      }
    })
  }

  rowSelected(event: any) {}
}
